import { useContext } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import AppContext from "../../../AppContext";
import AppointmentNoteContentBuilder, {
  AppointmentNoteTagProps
} from "../../../Notes/Compositions/AppointmentNoteContentBuilder";
import IReservation from "../../../types/IReservation";
import { IConfirmedAppointmentResponse } from "../hooks/useConfirmAppointment";
import useConfirmAppointment from "../hooks/useConfirmAppointment";
import useCreateContactResult from "../hooks/useCreateContactResult";

/** A composed hook used to confirm an appointment. */
const AppContextUseConfirmAppointment: TriggeredHook<IConfirmedAppointmentResponse, IReservation, boolean> = () => {
  const { defaultCenter, patient, contactId, medicalConclusions, reservation } = useContext(AppContext);
  return useConfirmAppointment({
    useCreateContactResult,
    noteProps: {
      patient: patient,
      medicalConclusions,
      reservation: reservation!,
      center: defaultCenter
    } as AppointmentNoteTagProps,
    noteContentBuilder: AppointmentNoteContentBuilder,
    patient: patient,
    contactId: contactId
  });
};

export default AppContextUseConfirmAppointment;
